import { ChangeDetectionStrategy, Component, ElementRef, Inject } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ApiService } from '@core/api.service';
import { ProjectService } from '@features/project/project.service';
import { ToasterService } from '@ui-kit/app-toast/toaster.service';
import { handleError } from '@ui-kit/utility/handleHttpErrorResponse';
import { Collection } from 'collection';
import { CollectionModel } from 'collection';

@Component({
  selector: 'assign-employee',
  templateUrl: './assign-employee.component.html',
  styleUrls: ['./assign-employee.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignEmployeeComponent {
  form = new UntypedFormGroup({
    employee: new UntypedFormControl('', Validators.required)
  });
  collection: CollectionModel;
  employersCollection: CollectionModel;
  employeeModel: any;

  get nameControlError() {
    const nameControl = this.employeeControl;
    return nameControl.touched && nameControl.errors;
  }

  get employeeControl(): AbstractControl {
    return this.form.get('employee');
  }

  getEmployeesList({ search, page }): void {
    this.employersCollection.setParams('page', page);
    search.length
      ? this.employersCollection.setParams('filter_name', search)
      : this.employersCollection.clearParams('filter_name');
    this.employersCollection.search();
  }

  private assignEmployee(): void {
    this.collection.updateItem({ id: this.employeeControl.value }).subscribe(
      (res) => {
        this.data.subject.next(res.data);
        this._dialogRef.close();
        this._toastService.show({
          type: 'success',
          message: marker('Changes are successfully saved')
        });
      },
      (err) => {
        const errorResponse = err.error;
        handleError(errorResponse, this._toastService);
      }
    );
  }

  submit(): void {
    if (this.employeeControl.valid) {
      this.assignEmployee();
    } else {
      this.employeeControl.markAsTouched({ onlySelf: true });
    }
  }

  constructor(
    private _elemRef: ElementRef,
    private _api: ApiService,
    private _toastService: ToasterService,
    public _dialogRef: MatDialogRef<any>,
    private _projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.collection = _projectService.assignUserCollection;

    this.employersCollection = new Collection({
      api: this._api.workers,
      params: {
        status: 'active',
        expand: 'full_name',
        role: 'worker,manager'
      }
    });

    this.employersCollection.loadByScrolling = true;
  }
}
